import { render, staticRenderFns } from "./Noise.vue?vue&type=template&id=3705a6f5&scoped=true&"
import script from "./Noise.vue?vue&type=script&lang=js&"
export * from "./Noise.vue?vue&type=script&lang=js&"
import style0 from "./Noise.vue?vue&type=style&index=0&id=3705a6f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3705a6f5",
  null
  
)

export default component.exports